import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ViewAsProvider } from "@/context/ViewAsContext";
import LandingPage from "@/pages/LandingPage";
import LPFlex4Success, { LPFlex4SuccessDanke } from "@/pages/LPFlex4Success";
import LPPocketCoach, { LPPocketCoachDanke, LPAbgesprochen } from "@/pages/LPPocketCoach";
import { KT400Team, KT400Privat, KT400Pause, KT400Wahl } from "@/pages/KT400";
import AdminKT400 from "@/pages/AdminKT400";
import AdminDream100 from "@/pages/AdminDream100";
import TuerEinschaetzung from "@/pages/TuerEinschaetzung";
import LPPocketCoachTest, { LPPocketCoachTestDanke, LPPocketCoachTestErgebnis } from "@/pages/LPPocketCoachTest";
import MagicConfirm from "@/pages/MagicConfirm";
import FlexCoachDemo from "@/pages/FlexCoachDemo";
// Sprint M5.23 (29.07.2026) — M-11 Meine Primärfokustyp-Analyse (Pro-Modul).
import ProAnalysisWizard from "@/pages/ProAnalysisWizard";
import DashboardPowerPaket from "@/pages/DashboardPowerPaket";
import DashboardRecommendations from "@/pages/DashboardRecommendations";
import DashboardBegegnungsDynamik from "@/pages/DashboardBegegnungsDynamik";
import DashboardRuheImChaos from "@/pages/DashboardRuheImChaos";
// Sprint M5.23-Ergaenzung (28.07.2026) — Admin-Feedback-Overview.
import AdminFeedbackOverview from "@/pages/AdminFeedbackOverview";
// Sprint V29 (Fr 27.02.2026) — Admin Landing-Analytics (A/B-Test-Auswertung).
import AdminLandingAnalytics from "@/pages/AdminLandingAnalytics";
import AdminQuestionSetAB from "@/pages/AdminQuestionSetAB";
import DashboardEntry from "@/pages/DashboardEntry";
import Login from "@/pages/Login";
import CoCreator from "@/pages/CoCreator";
import CoCreatorResult from "@/pages/CoCreatorResult";
import Pricing from "@/pages/Pricing";
import Dashboard from "@/pages/Dashboard";
import DashboardFokustyp from "@/pages/DashboardFokustyp";
import DashboardAnliegen from "@/pages/DashboardAnliegen";
import DashboardFokustypDetail from "@/pages/DashboardFokustypDetail";
import DashboardDreisatzBruecke from "@/pages/DashboardDreisatzBruecke";
import DashboardAbo from "@/pages/DashboardAbo";
import DashboardTest from "@/pages/DashboardTest";
import DashboardTestResult from "@/pages/DashboardTestResult";
import DashboardCoCreator from "@/pages/DashboardCoCreator";
import WelcomePage from "@/pages/WelcomePage";
import WelcomePlan from "@/pages/WelcomePlan";
import ConfirmHintPage from "@/pages/ConfirmHintPage";
import StatusPage from "@/pages/StatusPage";
// Sprint V41 (Mo 15.09.2026, CoS-Quick-Win) — Pfad-basierte Share-Link-Route.
import ViaRedirect from "@/pages/ViaRedirect";
import Cockpit from "@/pages/Cockpit";
// Sprint V98 (Do 17.09.2026, Andreas via CH-00) — Webinar Registration Flow
import WebinarRegpage from "@/pages/WebinarRegpage";
import WebinarConfirmed from "@/pages/WebinarConfirmed";
// Sprint V100+ (Do 18.09.2026) — KlickTipp DOI Landing-Pages.
import WebinarDoiConfirmed from "@/pages/WebinarDoiConfirmed";
import WebinarWillkommen from "@/pages/WebinarWillkommen";
import Mitgestalten from "@/pages/Mitgestalten";
import CancellationScreen from "@/pages/CancellationScreen";
import AdminBootstrap from "@/pages/AdminBootstrap";
// Sprint V101.b (Sa 20.09.2026) — Admin-Webinar-Panel (Termin & Zoom editieren).
import AdminWebinar from "@/pages/AdminWebinar";
import AdminMarketing from "@/pages/AdminMarketing";
// Sprint V101.d (Sa 20.09.2026) — Admin-Cockpit Overview + shared Token-Context.
import AdminHome from "@/pages/AdminHome";
import { AdminTokenProvider } from "@/context/AdminTokenContext";
import Register from "@/pages/Register";
import HeartPieceV3Page from "@/pages/HeartPieceV3Page";
import CookieBanner from "@/components/CookieBanner";
import { LegalFooterLine } from "@/components/LegalFooterLine";
// Sprint Redesign v1 (Do 03.09.2026) — Feature-Flag + neue Redesign-Pages.
import { REDESIGN_V2_ENABLED } from "@/lib/featureFlags";
import RedesignDashboard from "@/pages/redesign/RedesignDashboard";
import PageMeinMuster from "@/pages/redesign/PageMeinMuster";
import PageAndereVerstehen from "@/pages/redesign/PageAndereVerstehen";
import PageWirkungGestalten from "@/pages/redesign/PageWirkungGestalten";
import PageVideoKurs from "@/pages/redesign/PageVideoKurs";
import PageAnliegen from "@/pages/redesign/PageAnliegen";
import PageProfil from "@/pages/redesign/PageProfil";
import AccountDeleted from "@/pages/AccountDeleted";
import SchnellerZugang from "@/pages/SchnellerZugang";
// oct26 eingefroren: alte Einstiegsseite pages/ChallengeJoin.jsx bleibt als Referenz, Route nutzt ChallengeJoinV2.
import EinladungPocketCoach from "@/pages/EinladungPocketCoach";
import WillkommenPocketCoach from "@/pages/WillkommenPocketCoach";
import AdminKohorten from "@/pages/AdminKohorten";
import AdminEntscheidungen from "@/pages/AdminEntscheidungen";
import AdminChallenge from "@/pages/AdminChallenge";
import FormelLandingPage from "@/pages/FormelLandingPage";
import ChallengeJoinV2 from "@/pages/ChallengeJoinV2";
import ChallengeWrapup from "@/pages/ChallengeWrapup";
import ChallengeWillkommen from "@/pages/ChallengeWillkommen";
import ChallengeTag from "@/pages/ChallengeTag";
import PionierConfirm from "@/pages/PionierConfirm";
import PionierDanke from "@/pages/PionierDanke";
import BestaetigeDeineEmail from "@/pages/BestaetigeDeineEmail";
import OneClickOptIn from "@/pages/OneClickOptIn";
// V1.E (Launch-Consolidation, 30.08.2026): WartelistePage hidden.
// /warteliste redirected auf /start (siehe Route unten). Dead import entfernt.
// import WartelistePage from "@/pages/WartelistePage";
import PionierCockpit from "@/pages/PionierCockpit";
import VideoIndoctrination from "@/pages/VideoIndoctrination";
import PionierQuickCheck from "@/pages/PionierQuickCheck";
// Sprint V100 (17.09.2026) — Dedizierte QuickCheck-LP fuer Cold-Traffic.
import QuickCheckLanding from "@/pages/QuickCheckLanding";
import ProtectedRoute from "@/components/ProtectedRoute";
import NotFoundPage from "@/pages/NotFoundPage";
import PionierErrorBoundary from "@/components/PionierErrorBoundary";
import PrelaunchGuard from "@/components/PrelaunchGuard";
import PionierOptIn from "@/pages/PionierOptIn";
import PionierOnboarding from "@/pages/PionierOnboarding";
import { ImpressumPage, DatenschutzPage, KontaktPage } from "@/pages/LegalPages";
import { loadJourneyFlags } from "@/lib/journeyFlags";

loadJourneyFlags();

// Sprint 11.6 Block 2 (Task 5) — RegisterRedirect entfernt. /register zeigt
// jetzt das Register-Formular (Email + Passwort + Vorname). Query-Params
// fokustyp + source werden in Register.jsx aufgegriffen (Conversion-Boost).

function useHideEmergentBadge() {
  useEffect(() => {
    const removeBadge = () => {
      const el = document.getElementById("emergent-badge");
      if (el && el.parentNode) {
        el.parentNode.removeChild(el);
      }
    };
    removeBadge();
    const observer = new MutationObserver(removeBadge);
    observer.observe(document.body, { childList: true, subtree: true });
    return () => observer.disconnect();
  }, []);
}

function App() {
  useHideEmergentBadge();
  // POSTLAUNCH-V5 · P0-#4 (Fr 04.09.2026) — Font-Scale aus localStorage anwenden.
  useEffect(() => {
    try {
      const saved = localStorage.getItem("f4s_font_scale") || "1";
      document.documentElement.style.setProperty("--fts-font-scale", saved);
    } catch { /* ignore */ }
  }, []);
  // Sprint V1.7 Referral-Engine System A (09.09.2026) — `?ref=CODE` capture.
  // Wird beim Ersten Landing-Aufruf in localStorage geschrieben (30 Tage TTL).
  // Register.jsx liest das Feld beim Sign-Up und leitet es an /api/auth/register.
  useEffect(() => {
    try {
      const params = new URLSearchParams(window.location.search);
      const ref = (params.get("ref") || "").trim().toUpperCase();
      if (ref && /^[A-Z0-9]{4,24}$/.test(ref)) {
        const now = Date.now();
        const payload = { code: ref, ts: now, ttl: 30 * 24 * 60 * 60 * 1000 };
        localStorage.setItem("f4s_ref_code", JSON.stringify(payload));
      }
    } catch { /* ignore */ }
  }, []);
  // Sprint V33 (Sa 14.09.2026) — Funnel-Attribution: cancel_before_complete
  // feuern, wenn ein add_to_cart-Pending-Flag > 30s alt ist und der User
  // zurueckkommt ohne Purchase. Marker-Clean beim Purchase.
  useEffect(() => {
    const path = window.location.pathname || "";
    if (path.startsWith("/willkommen")) return;
    const t = setTimeout(() => {
      try {
        import("@/lib/ga4").then((m) => m.detectCancelBeforeComplete?.());
      } catch { /* ignore */ }
    }, 1500);
    return () => clearTimeout(t);
  }, []);
  // Sprint V40 (Di 15.02.2026) — CoS-Sprint-Tag: consent-unabhaengiger
  // Server-Side-PageView-Beacon. Feuert bei JEDEM App-Mount, unabhaengig vom
  // Cookie-Banner-Zustand. Zaehlt Traffic-Volumen zur Diagnose von Klick-zu-
  // LP-Rate-Discrepancy (Client-Side-GA4 zeigt nur ~15% wegen DACH-Consent).
  useEffect(() => {
    try {
      const url = new URL(window.location.href);
      const params = url.searchParams;
      const body = {
        path: url.pathname || "/",
        referrer: document.referrer || "",
        utm_source: params.get("utm_source") || null,
        utm_medium: params.get("utm_medium") || null,
        utm_campaign: params.get("utm_campaign") || null,
        hook_variant: (() => {
          try { return localStorage.getItem("f4s_hook_variant"); } catch { return null; }
        })(),
        test_run: !!window.__f4s_testMode,
      };
      const apiBase = process.env.REACT_APP_BACKEND_URL || "";
      const beaconUrl = `${apiBase}/api/analytics/pv`;
      if (navigator.sendBeacon) {
        navigator.sendBeacon(beaconUrl, new Blob([JSON.stringify(body)], { type: "application/json" }));
      } else {
        fetch(beaconUrl, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(body), keepalive: true }).catch(() => {});
      }
    } catch { /* silent */ }
  }, []);
  return (
    <div className="App">
      <AuthProvider>
        <ViewAsProvider>
        <AdminTokenProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<PrelaunchGuard><LandingPage /></PrelaunchGuard>} />
            {/* Sprint V41 (Mo 15.09.2026, CoS-Quick-Win) — Pfad-basierter
                Share-Link (`/via/:code`) statt UTM-Rattenschwanz. Setzt
                Referral-Code in localStorage und redirected zu `/`. */}
            <Route path="/via/:code" element={<ViaRedirect />} />
            {/* Sprint-V25 Issue L (Sa 12.09.2026) — Preview-Route fuer die neue
                Public-Landing-Page (Hero-Hook-Varianten + Story + Offer).
                Umgeht PrelaunchGuard bewusst, damit Andreas die neue Copy
                auch waehrend aktivem PRELAUNCH_MODE reviewen kann. */}
            <Route path="/lp-preview" element={<LandingPage />} />
            {/* Sprint M5.23 (24.07.2026) — Dedicated LP fuer Meta-Ads-Traffic.
                Umgeht PrelaunchGuard bewusst, damit Cold-Traffic direkt landet. */}
            <Route path="/lp/flex4success" element={<LPFlex4Success />} />
            <Route path="/lp/flex4success/danke" element={<LPFlex4SuccessDanke />} />
            <Route path="/lp/pocketcoach" element={<LPPocketCoach />} />
            <Route path="/lp/pocketcoach/danke" element={<LPPocketCoachDanke />} />
            <Route path="/lp/pocketcoach-test" element={<LPPocketCoachTest />} />
            <Route path="/lp/pocketcoach-test/danke" element={<LPPocketCoachTestDanke />} />
            <Route path="/lp/pocketcoach-test/ergebnis" element={<LPPocketCoachTestErgebnis />} />
            <Route path="/lp/abgesprochen" element={<LPAbgesprochen />} />
            <Route path="/lp/kt400-team" element={<KT400Team />} />
            <Route path="/lp/kt400-privat" element={<KT400Privat />} />
            <Route path="/lp/kt400-pause" element={<KT400Pause />} />
            <Route path="/lp/kt400-wahl" element={<KT400Wahl />} />
            <Route path="/lp/einschaetzung" element={<TuerEinschaetzung />} />
            <Route path="/login/bestaetigen" element={<MagicConfirm />} />
            {/* Sprint M5.39 (28.07.2026) — FlexCoach-Demo-Seite (Phase 2). */}
            <Route path="/flex-coach" element={<FlexCoachDemo />} />
            {/* Sprint M5.23 (29.07.2026) — M-11 Meine Primärfokustyp-Analyse. */}
            <Route path="/dashboard/pro-analyse" element={<ProAnalysisWizard />} />
            {/* Sprint M5.35 (29.07.2026) — PowerPaket-In-App-Bereich (Stub). */}
            <Route path="/dashboard/powerpaket" element={<DashboardPowerPaket />} />
            <Route path="/dashboard/recommendations" element={<DashboardRecommendations />} />
            <Route path="/dashboard/begegnungs-dynamik" element={<DashboardBegegnungsDynamik />} />
            <Route path="/dashboard/courses/ruhe-im-chaos" element={<DashboardRuheImChaos />} />
            {/* Sprint M5.23-Ergaenzung (28.07.2026) — Admin Feedback Overview. */}
            <Route path="/admin/feedback" element={<AdminFeedbackOverview />} />
            <Route path="/admin/landing-analytics" element={<AdminLandingAnalytics />} />
            <Route path="/admin/kohorten" element={<AdminKohorten />} />
            <Route path="/admin/entscheidungen" element={<AdminEntscheidungen />} />
            <Route path="/admin/challenge" element={<AdminChallenge />} />
            <Route path="/admin/kt400" element={<AdminKT400 />} />
            <Route path="/admin/dream100" element={<AdminDream100 />} />
            <Route path="/admin/questionset-ab" element={<AdminQuestionSetAB />} />
            {/* Sprint V98 (Do 17.09.2026) — Webinar Registration Flow */}
            <Route path="/webinar/:id/anmeldung" element={<WebinarRegpage />} />
            <Route path="/webinar/:id/bestaetigung" element={<WebinarConfirmed />} />
            {/* Sprint V100+ (18.09.2026) — KlickTipp DOI Landing-Pages */}
            <Route path="/webinar/doi-bestaetigt" element={<WebinarDoiConfirmed />} />
            <Route path="/webinar/willkommen" element={<WebinarWillkommen />} />
            {/* Sprint 12+K-Hotfix7 (08.07.2026) — Klick-Tipp Smart-Link Pionier-Opt-In */}
            <Route path="/pionier-opt-in" element={<PionierOptIn />} />
            {/* Sprint 12+L4.2 (14.07.2026) — Konsolidiert: /pionier-opt-in/danke → /warteliste/danke */}
            <Route path="/pionier-opt-in/danke" element={<Navigate to="/warteliste/danke" replace />} />
            <Route path="/willkommen" element={<WelcomePage />} />
            {/* Sprint M5.56b (14.08.2026) — Ablefy Post-Purchase Welcome-Seiten.
                Ablefy leitet nach Kauf hierher weiter und haengt automatisch
                order_token, payer_email, product, recurring_form als Query an. */}
            <Route path="/flex4success/welcome/pro-solo-monthly" element={<WelcomePlan plan="pro-solo-monthly" />} />
            <Route path="/flex4success/welcome/pro-solo-annual" element={<WelcomePlan plan="pro-solo-annual" />} />
            <Route path="/flex4success/welcome/power-paket" element={<WelcomePlan plan="power-paket" />} />
            <Route path="/login" element={<Login />} />
            {/* Sprint M5.24.3 (24.07.2026) — Pionier-safe Login-Alias fuer
                KlickTipp-Broadcast-Mails an bestehende Pioniere. Kein
                „Registrieren"-CTA im Header, angepasste Copy. */}
            <Route path="/pionier-login" element={<Login pionierMode />} />
            <Route path="/register" element={<PrelaunchGuard><Register /></PrelaunchGuard>} />
            {/* Sprint 12+I3 Hotfix (04.07.2026) — /self-test deprecated,
                Redirect zur Landing-Page (Quick-Check ist dort integriert). */}
            <Route path="/self-test" element={<Navigate to="/" replace />} />
            <Route path="/self-test/result" element={<Navigate to="/" replace />} />
            <Route path="/co-creator" element={<PrelaunchGuard><CoCreator /></PrelaunchGuard>} />
            <Route path="/co-creator/result" element={<PrelaunchGuard><CoCreatorResult /></PrelaunchGuard>} />
            {/* Launch-Blocker L-3 (02.09.2026) — /pricing MUSS immer erreichbar
                sein (Preise-Button-Fix). Ohne PrelaunchGuard-Wrapper, damit
                logged-in Free-User nicht zurück ins Cockpit redirected werden. */}
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/status" element={<StatusPage />} />
            {/* Sprint Redesign v1 (Do 03.09.2026) — Feature-Flag REACT_APP_REDESIGN_V2:
                Neue 7-Routen-Architektur (/dashboard als Landing + 6 dedizierte Pages).
                /cockpit wird Alias-Redirect auf /dashboard (Backward-Compat).
                Fallback bei Flag=false: bestehender Cockpit-Stand bleibt aktiv. */}
            {REDESIGN_V2_ENABLED ? (
              <>
                <Route path="/cockpit" element={<Navigate to="/dashboard" replace />} />
                <Route path="/mein-muster" element={<PageMeinMuster />} />
                <Route path="/andere-verstehen" element={<PageAndereVerstehen />} />
                <Route path="/wirkung-gestalten" element={<PageWirkungGestalten />} />
                <Route path="/videokurs" element={<PageVideoKurs />} />
                <Route path="/anliegen" element={<PageAnliegen />} />
                <Route path="/profil" element={<PageProfil />} />
              </>
            ) : (
              <Route path="/cockpit" element={<Cockpit />} />
            )}
            {/* Sprint V103 (Mo 21.09.2026) — DSGVO Art. 17 Bestaetigungsseite.
                Kein Auth-Guard: nach Konto-Loeschung ist der User ausgeloggt,
                soll aber trotzdem die Bestaetigung sehen. */}
            <Route path="/geloescht" element={<AccountDeleted />} />

            {/* Sprint V102 (Mo 21.09.2026) — Schneller-Zugang-Landing.
                Public route — Consent-basiertes Signup fuer DOI-bestaetigte
                Kontakte via signierter Token-URL.
                Route umbenannt von /willkommen-zurueck auf /schneller-zugang
                (kein Welcome-Back-Framing — die User waren nie in der App). */}
            <Route path="/schneller-zugang" element={<SchnellerZugang />} />
            {/* Trailing-Slash-Variante (KlickTipp-Editor haengt manchmal / an) */}
            <Route path="/schneller-zugang/" element={<SchnellerZugang />} />
            {/* Legacy-Redirect fuer bereits versandte Test-Links */}
            <Route path="/willkommen-zurueck" element={<SchnellerZugang />} />
            {/* Sprint V103.ch (Fr 02.10.2026) — 5-Tage-Challenge-Join
                Public routes — Ein-Klick-Beitritt aus KT-Freitagsmail +
                Return-Page nach Ablefy-Zahlung. */}
            <Route path="/challenge-join" element={<ChallengeJoinV2 />} />
            <Route path="/challenge-join/" element={<ChallengeJoinV2 />} />
            {/* Sprint V104 (06.10.2026) — Pocket-Coach-Einladungsseite fuer
                persoenliche Kontakte. URL: /einladung?fn=Petra */}
            <Route path="/einladung" element={<EinladungPocketCoach />} />
            <Route path="/zugang" element={<WillkommenPocketCoach />} />
            <Route path="/einladung/" element={<EinladungPocketCoach />} />
            <Route path="/challenge/willkommen" element={<ChallengeWillkommen />} />
            <Route path="/challenge/willkommen/" element={<ChallengeWillkommen />} />
            <Route path="/challenge/tag/:day" element={<ChallengeTag />} />
            <Route path="/challenge/wrapup" element={<ChallengeWrapup />} />
            <Route path="/4-fokustypen-formel" element={<FormelLandingPage />} />
            <Route path="/4-fokustypen-formel-special" element={<FormelLandingPage />} />
            {/* Sprint 8.F — Mitgestalten Feedback-Schnittstelle */}
            <Route path="/mitgestalten" element={<PrelaunchGuard><Mitgestalten /></PrelaunchGuard>} />
            {/* Kontakt-Link-Feedback (Do10.09.2026, 18:15) — /feedback Alias fuer
                Kontakt-Zwecke, mount identisch auf Mitgestalten. Pre-Launch offen. */}
            <Route path="/feedback" element={<Mitgestalten />} />
            {/* Sprint 8.D — Kündigungs-Screen mit Asset-Verlust + 30-Tage-Pause */}
            <Route path="/cancel" element={<CancellationScreen />} />
            {/* Hotfix v14b — Admin-only Bootstrap-Promote-Tool */}
            <Route path="/admin/users" element={<AdminBootstrap />} />
            {/* Sprint V101.b (Sa 20.09.2026) — Admin-Panel für Webinar-Termin */}
            <Route path="/admin/webinar" element={<AdminWebinar />} />
            {/* Sprint V102.j (So 27.09.2026) — Admin-Panel fuer Marketing-Banner + In-App-Kampagnen */}
            <Route path="/admin/marketing" element={<AdminMarketing />} />
            {/* Sprint V101.d (Sa 20.09.2026) — Admin-Cockpit Overview */}
            <Route path="/admin" element={<AdminHome />} />
            {/* Phase 4 Dashboard */}
            {/* Hotfix v14f — /dashboard alleinstehend redirected zu /cockpit (alleiniger Hub).
                Sub-Routen /dashboard/* (anliegen, fokustyp, abo, …) bleiben funktional. */}
            {/* Sprint 12+K (07.07.2026) — /dashboard mit Auth-Guard + Login-UI.
                Sprint Redesign v1 (Do 03.09.2026): Wenn Feature-Flag aktiv, wird
                /dashboard zur neuen Landing-Page mit Kachel-Hub. */}
            <Route
              path="/dashboard"
              element={REDESIGN_V2_ENABLED ? <RedesignDashboard /> : <DashboardEntry />}
            />
            <Route path="/dashboard/fokustyp" element={REDESIGN_V2_ENABLED ? <Navigate to="/andere-verstehen" replace /> : <DashboardFokustyp />} />
            <Route path="/dashboard/fokustyp/:slug" element={<DashboardFokustypDetail />} />
            <Route path="/dashboard/3-satz-bruecke" element={<DashboardDreisatzBruecke />} />
            <Route path="/dashboard/abo" element={<DashboardAbo />} />
            <Route path="/dashboard/test" element={<DashboardTest />} />
            <Route path="/dashboard/test/result" element={<DashboardTestResult />} />
            <Route path="/dashboard/co-creator" element={<DashboardCoCreator />} />
            <Route path="/dashboard/anliegen" element={<DashboardAnliegen />} />
            {/* Sprint 11.6 Block 2 (Task 2) — Flexpfad-Bibliothek V3: 3 Bausteine pro FT */}
            <Route path="/dashboard/heart-piece-v3" element={<HeartPieceV3Page />} />
            {/* Sprint 12+B (02.07.2026) — Pionier Confirm-Flow via URL-Token */}
            {/* Boardroom 26.08.2026 (Pre-Launch) — Chief-of-Staff-Direktive:
                Alte Marketing-Links auf /warteliste zeigen jetzt auf die neue
                Landing-Page /start. Sub-Routen /warteliste/confirm etc. bleiben
                unveraendert (React-Router matcht exact-path zuerst).
                Rueckwaertskompatibilitaet: /lp/flex4success bleibt weiter live. */}
            <Route path="/warteliste" element={<Navigate to="/start" replace />} />
            <Route path="/start" element={<LPFlex4Success />} />
            <Route path="/impressum" element={<ImpressumPage />} />
            <Route path="/datenschutz" element={<DatenschutzPage />} />
            <Route path="/kontakt" element={<KontaktPage />} />
            <Route path="/warteliste/confirm" element={<PionierErrorBoundary><PionierConfirm /></PionierErrorBoundary>} />
            <Route path="/warteliste/danke" element={<PionierErrorBoundary><PionierDanke /></PionierErrorBoundary>} />
            {/* Sprint 12+L4.8.3 (16.07.2026) — Free-User-Pattern: KT sendet
                ?subscriberKey=<KEY> an /bestaetige-deine-email; die Bridge
                mappt subscriberKey → confirm_token via Backend und redirected
                auf /warteliste/danke?token=<TOKEN>. */}
            <Route path="/bestaetige-deine-email" element={<PionierErrorBoundary><BestaetigeDeineEmail /></PionierErrorBoundary>} />
            {/* Sprint 12+H (03.07.2026) — Dedizierter Pionier-only Confirm-Endpoint.
                Sprint 12+L4.2 (14.07.2026) — konsolidiert auf dieselbe PionierConfirm-
                Komponente (wählt Backend-Endpoint anhand des Pfads). */}
            <Route path="/warteliste/pionier-confirm" element={<PionierErrorBoundary><PionierConfirm /></PionierErrorBoundary>} />
            {/* Sprint 12+F (03.07.2026) — One-Click Auto-Login aus SOAP-06-Mail */}
            <Route path="/warteliste/one-click" element={<OneClickOptIn />} />
            {/* Sprint 12+ (03.07.2026, ~17:00) — Pionier-Cockpit (3 Sektionen) */}
            <Route
              path="/dashboard/pionier"
              element={
                <PionierErrorBoundary>
                  <ProtectedRoute requirePionier={true}>
                    <PionierCockpit />
                  </ProtectedRoute>
                </PionierErrorBoundary>
              }
            />
            {/* Sprint 12+M5.17-t (22.07.2026) — Vimeo Indoctrination-Sequence
                (5 Videos, Intro sofort + Katze/Eule/Biene/Hund per Drip). */}
            <Route
              path="/dashboard/pionier/videos"
              element={
                <PionierErrorBoundary>
                  <ProtectedRoute requirePionier={true}>
                    <VideoIndoctrination />
                  </ProtectedRoute>
                </PionierErrorBoundary>
              }
            />
            {/* Sprint M5.36 (29.07.2026) — Scope-Angleichung: Free-User bekommen
                die identische 5-Video-Bibliothek wie Pioniere. Kein separater
                Component, gleiche Komponente unter offener Route. */}
            <Route
              path="/dashboard/videos"
              element={
                <ProtectedRoute>
                  <VideoIndoctrination />
                </ProtectedRoute>
              }
            />
            {/* Sprint 12+I (04.07.2026) — Pionier-Quick-Check (5 Fragen) */}
            {/* Sprint 12+M1 (15.07.2026) — Auth-Guard erfolgt jetzt IN der
                Komponente selbst, damit `?token=<43>` gegen Cookie getauscht
                werden kann bevor auf /login redirected wird.
                Sprint 12+M5.11 (19.07.2026) — Fallback jetzt /warteliste/one-click
                statt /login (harte Trennung Pionier ↔ Free/Paid).
                Sprint V101 (27.02.2026) — Alt-Route: Hard-Redirect auf V100
                /quickcheck. Verhindert dass alte Bookmarks am neuen Router
                vorbei den alten Pionier-Test aufrufen. */}
            <Route
              path="/pionier-quick-check"
              element={<Navigate to="/quickcheck" replace />}
            />
            {/* Sprint V100 (17.09.2026) — QuickCheck-Landingpage fuer Cold-Traffic. */}
            <Route path="/quickcheck" element={<QuickCheckLanding />} />
            {/* Sprint 12+L2 (15.07.2026) — Pionier-Onboarding (Lite + Detail) */}
            <Route
              path="/pionier-onboarding"
              element={
                <PionierErrorBoundary>
                  <ProtectedRoute requirePionier={true}>
                    <PionierOnboarding />
                  </ProtectedRoute>
                </PionierErrorBoundary>
              }
            />
            {/* POSTLAUNCH-V4 · M404 (Do 03.09.2026) — 404-Charmeseite mit
                Fokustyp-Icons + Türöffner-Wortspiel statt stiller Redirect. */}
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
          <LegalFooterLine />
        </BrowserRouter>
        <Toaster position="top-center" richColors />
        <CookieBanner />
        </AdminTokenProvider>
        </ViewAsProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
